import React from "react";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";

const ActiveUserInfo = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const onSubmit = () => {
    if (!activeUserDetail) {
      return toast.error("User details not found or Your KYC is incomplete. Thank You!");
    }
    setStep("CheckPrevRequest");
  };
  return (
    <div>
      <Title title="User Details For Email Modification" />
      <div className="col-md-9 mt-3">
        <div className="ml-2">
          {activeUserDetail && (
            <div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">Full Name</h6>
                  <div className="col-sm">{activeUserDetail.full_name}</div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">Mobile Number</h6>
                  <div className="col-sm">{activeUserDetail.phone?.slice(2)}</div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">Email Address</h6>
                  <div className="col-sm">{activeUserDetail.email}</div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">PAN Number</h6>
                  <div className="col-sm">{activeUserDetail.poi?.[0]?.pan_number}</div>
                </div>
              </div>
            </div>
          )}
          <div className="d-flex mt-4">
            <div className="ml-2">
              <Button
                title="Back"
                type="button"
                handleClick={() => setStep("ValidatePan")}
                loading={isLoading}
              />
            </div>
            <div className="mx-2">
              <Button title="Next" handleClick={() => onSubmit()} loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveUserInfo;
